import React from "react";
import renok from "./renok.png"; // Import the image
import empty from "./empty.gif"; // Import the image

const WebsiteUpdateNotice = () => {
  return (
    <div style={styles.container}>
      <title>RENOK</title>
      <div style={styles.card}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src={renok}
            alt="Maintenance"
            style={{ width: 150}}
          />
          <img
            src={empty}
            alt="Maintenance"
            style={{ width: 200, marginBottom: 10 }}
          />
        </div>
        <h1 style={styles.title}>🚧 We’re Updating Our Website!</h1>
        <p style={styles.message}>
          We’re currently working on something awesome. Please check back soon.
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: "100vh",
    width: "100%",
    background: "linear-gradient(135deg, #55efc4 0%, #6c5ce7 100%)", // gradient background
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
    boxSizing: "border-box",
  },
  card: {
    backgroundColor: "#ffffff",
    borderRadius: 16,
    padding: 50,
    maxWidth: 500,
    width: "100%",
    textAlign: "center",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)",
  },
  title: {
    fontSize: 26,
    color: "#1f2937",
    marginBottom: 16,
  },
  message: {
    fontSize: 18,
    color: "#4b5563",
  },
};

export default WebsiteUpdateNotice;
